import { render, staticRenderFns } from "./TxRowSkeletonMobile.vue?vue&type=template&id=611faa13&scoped=true&functional=true"
var script = {}
import style0 from "./TxRowSkeletonMobile.vue?vue&type=style&index=0&id=611faa13&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "611faa13",
  null
  
)

export default component.exports